<template>
    <el-drawer
        title="推送详情"
        :visible.sync="visible"
        :wrapperClosable="false"
        size="auto"
        @closed="closed"
    >
        <div v-loading="fetchLoading" class="drawer-content">
            <table v-if="data" class="info-table" width="100%" style="table-layout: fixed;">
                <tr>
                    <th width="130">推送标题:</th>
                    <td>{{data.title}}</td>
                </tr>
                <tr>
                    <th>消息内容:</th>
                    <td>{{ data.document }}</td>
                </tr>
                <tr>
                    <th>消息类型:</th>
                    <td>
                        <span v-if="data.pushObjType === 1">演出</span>
                        <span v-if="data.pushObjType === 2">众筹</span>
                        <span v-if="data.pushObjType === 3">自定义</span>
                        <span v-if="data.pushObjType === 4">巡演</span>
						<span v-if="data.pushObjType === 5">粉丝通告</span>
						<span v-if="data.pushObjType === 11">演出上新</span>
                    </td>
                </tr>
                <tr>
                    <th>对象ID/链接:</th>
                    <td>
                        <span v-if="data.pushObjType === 3">{{data.url}}</span>
                        <span v-else>{{data.pushObjId}}</span>
                    </td>
                </tr>
                <tr>
                    <th>触达用户:</th>
                    <td>
                        <span v-if="data.touchActivity === 1" class="MR10"><span class="el-icon-check"></span>演出用户</span>
                        <span v-if="data.touchUser === 1" class="MR10"><span class="el-icon-check"></span>手动指定用户</span>
                        <span v-if="data.touchCity === 1" class="MR10"><span class="el-icon-check"></span>特定城市用户</span>
                        <span v-if="data.touchFans === 1" class="MR10"><span class="el-icon-check"></span>粉丝用户</span>
						<span v-if="data.touchCircle === 1"><span class="el-icon-check"></span>标签圈选用户</span>
                    </td>
                </tr>
                <tr>
                    <th>推送平台:</th>
                    <td>
                        <span v-if="data.terminal === 1" class="MR10"><span class="el-icon-check"></span>Android</span>
                        <span v-if="data.terminal === 2" class="MR10"><span class="el-icon-check"></span>IOS</span>
                        <span v-if="data.terminal === 0"><span class="el-icon-check"></span>Android<span class="el-icon-check ML10"></span>IOS</span>
                    </td>
                </tr>
                <tr>
                    <th>推送人数:</th>
                    <td>{{data.totalUser}}</td>
                </tr>
                <tr>
                    <th>查看推送人数:</th>
                    <td>{{data.readPushListNum}}</td>
                </tr>
                <tr>
                    <th>查看详情人数:</th>
                    <td>{{data.readPushDetailNum}}</td>
                </tr>
                <tr>
                    <th>推送人:</th>
                    <td>{{data.createUserName}}</td>
                </tr>
                <tr>
                    <th>推送时间:</th>
                    <td>{{data.createTime}}</td>
                </tr>
            </table>
        </div>
         <div class="drawer-footer">
            <el-button type="primary" @click="visible = false">确定</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
  components: {},
    data() {
        return {
            visible: false,
            data: null,
            fetchLoading: false
        };
    },
    methods: {
        async show(id) {
            this.visible = true;
            this.fetchLoading = true;
            const res = await this.$request({
                url: '/msg/push/info',
                method: 'post',
                params: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.fetchLoading = false;
            });

            const { state , msg, result } = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }

            this.data = result;
        },
        closed() {
            this.data = null;
        },
    }
};
</script>